/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ActivityLogDto } from '../../models/activity-log-dto';

export interface GetActivityLog$Params {
  fromDate?: string;
  toDate?: string;
  userId?: number;
}

export function getActivityLog(http: HttpClient, rootUrl: string, params?: GetActivityLog$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ActivityLogDto>>> {
  const rb = new RequestBuilder(rootUrl, getActivityLog.PATH, 'get');
  if (params) {
    rb.query('fromDate', params.fromDate, {});
    rb.query('toDate', params.toDate, {});
    rb.query('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ActivityLogDto>>;
    })
  );
}

getActivityLog.PATH = '/api/userActivityLog';
